import React, { useState, useEffect } from 'react';
import './App.css';
import db from './services/database';
import Header from './components/Header';
import HomePage from './components/HomePage';
import AdvancedSearch from './components/AdvancedSearch';
import MaterialDetails from './components/MaterialDetails';
import EntityManager from './components/EntityManager';

function App() {
  const [currentView, setCurrentView] = useState('home');
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [dbInitialized, setDbInitialized] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    initializeDatabase();
  }, []);

  const initializeDatabase = async () => {
    try {
      const success = await db.initialize();
      if (success) {
        setDbInitialized(true);
      } else {
        setError('Не вдалося ініціалізувати базу даних');
      }
    } catch (err) {
      setError('Помилка ініціалізації бази даних: ' + err.message);
    }
  };

  const handleMaterialSelect = (materialId) => {
    setSelectedMaterial(materialId);
  };

  const handleBack = () => {
    setSelectedMaterial(null);
  };

  if (!dbInitialized) {
    return (
      <div className="app">
        <Header currentView={currentView} setCurrentView={setCurrentView} />
        <div className="container">
          {error ? (
            <div className="error">
              <h2>Помилка</h2>
              <p>{error}</p>
            </div>
          ) : (
            <div className="loading">
              <div className="loading-spinner"></div>
              <p>Ініціалізація бази даних...</p>
              <p style={{ fontSize: '0.9rem', color: '#a0b0c0', marginTop: '1rem' }}>
                Це може зайняти кілька секунд при першому завантаженні
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (selectedMaterial) {
    return (
      <div className="app">
        <Header currentView={currentView} setCurrentView={(view) => {
          setCurrentView(view);
          setSelectedMaterial(null);
        }} />
        <div className="container">
          <MaterialDetails 
            materialId={selectedMaterial}
            onBack={handleBack}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <Header currentView={currentView} setCurrentView={setCurrentView} />
      <div className="container">
        {currentView === 'home' && (
          <HomePage setCurrentView={setCurrentView} />
        )}
        {currentView === 'advancedSearch' && (
          <AdvancedSearch setSelectedMaterial={handleMaterialSelect} />
        )}
        {currentView === 'entityManager' && (
          <EntityManager />
        )}
      </div>
    </div>
  );
}

export default App;
